import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { formatDate, handleImageError } from "helpers/globalFunction";
import Zoom from "react-medium-image-zoom";

const DetailModalLogProduct = ({ show, onCloseClick, data }: any) => {
  const isIncoming = data.type?.toLowerCase() === "masuk";

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="lg"
    >
      <ModalHeader
        className="border-0 pb-0"
        toggle={onCloseClick}
        // style={{
        //   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        // }}
      >
        <div className="text-white">
          <h5 className="mb-1 fw-semibold">Detail Catatan Barang</h5>
          <div className="d-flex align-items-center gap-2">
            <span
              className="badge rounded-pill px-3 py-2"
              style={{
                backgroundColor: isIncoming ? "#10b981" : "#ef4444",
                fontSize: "0.85rem",
              }}
            >
              {data.type || "-"}
            </span>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        {(data.firstPicture || data.secondPicture) && (
          <div className="mb-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <FeatherIcon icon="image" size={18} className="text-primary" />
              <h6 className="mb-0 text-muted">Foto Barang</h6>
            </div>
            <div className="row g-3">
              {data.firstPicture && (
                <div className="col-md-6">
                  <div
                    className="rounded-3 overflow-hidden shadow-sm border"
                    style={{ height: "200px" }}
                  >
                    <Zoom>
                      <img
                        src={data.firstPicture}
                        alt="Foto 1"
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        onError={handleImageError}
                      />
                    </Zoom>
                  </div>
                </div>
              )}
              {data.secondPicture && (
                <div className="col-md-6">
                  <div
                    className="rounded-3 overflow-hidden shadow-sm border"
                    style={{ height: "200px" }}
                  >
                    <Zoom>
                      <img
                        src={data.secondPicture}
                        alt="Foto 2"
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        onError={handleImageError}
                      />
                    </Zoom>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="row g-3">
          <div className="col-12">
            <div
              className="p-3 rounded-3 border"
              style={{ backgroundColor: "#f8fafc" }}
            >
              <div className="d-flex align-items-start gap-3">
                <div
                  className="rounded-2 p-2"
                  style={{ backgroundColor: "#e0e7ff" }}
                >
                  <FeatherIcon
                    icon="package"
                    size={20}
                    className="text-primary"
                  />
                </div>
                <div className="flex-grow-1">
                  <label className="text-muted small mb-1 d-block">
                    Nama Barang
                  </label>
                  <p className="mb-0 fw-semibold">{data.name || "-"}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="p-3 rounded-3 border h-100"
              style={{ backgroundColor: "#f8fafc" }}
            >
              <div className="d-flex align-items-start gap-3">
                <div
                  className="rounded-2 p-2"
                  style={{ backgroundColor: "#dbeafe" }}
                >
                  <FeatherIcon icon="user" size={20} className="text-info" />
                </div>
                <div className="flex-grow-1">
                  <label className="text-muted small mb-1 d-block">
                    Pengirim
                  </label>
                  <p className="mb-0 fw-semibold">{data.sender || "-"}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="p-3 rounded-3 border h-100"
              style={{ backgroundColor: "#f8fafc" }}
            >
              <div className="d-flex align-items-start gap-3">
                <div
                  className="rounded-2 p-2"
                  style={{ backgroundColor: "#fef3c7" }}
                >
                  <FeatherIcon
                    icon="calendar"
                    size={20}
                    className="text-warning"
                  />
                </div>
                <div className="flex-grow-1">
                  <label className="text-muted small mb-1 d-block">
                    Tanggal
                  </label>
                  <p className="mb-0 fw-semibold">
                    {formatDate(data.date, "fullDateTime")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div
              className="p-3 rounded-3 border"
              style={{ backgroundColor: "#f8fafc" }}
            >
              <div className="d-flex align-items-start gap-3">
                <div
                  className="rounded-2 p-2"
                  style={{ backgroundColor: "#dcfce7" }}
                >
                  <FeatherIcon
                    icon="file-text"
                    size={20}
                    className="text-success"
                  />
                </div>
                <div className="flex-grow-1">
                  <label className="text-muted small mb-1 d-block">
                    Catatan
                  </label>
                  <p className="mb-0" style={{ lineHeight: "1.6" }}>
                    {data.note || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

DetailModalLogProduct.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  data: PropTypes.any,
};

export default DetailModalLogProduct;
